import privacyPolicyJson from './content/privacyPolicy.json';

export const privacyPolicyMock = {
    layoutType: 2,
    data: {
        name: 'privacy-policy',
        areasList: [
            {
                id: 1,
                name: 'PrivacyPolicy',
                componentName: 'Comp:PrivacyPolicy',
                content: JSON.stringify(privacyPolicyJson)
            }
        ]
    }
};
